import React from "react";
import "../Services/Services.css";

const WhyChooseUsPreview = ({ previewService, setShowPreviewWhyChooseUs }) => {
    const service = previewService;
    if (!service) return null;

    const cards = service.cards || [];

    return (
        <div
            className="wcu-overlay"
            onClick={() => setShowPreviewWhyChooseUs(false)}
        >
            <div
                className="wcu-modal"
                onClick={(e) => e.stopPropagation()}
            >
       
                <button className="wcu-close" onClick={() => setShowPreviewWhyChooseUs(false)}>✕</button>

                <div className="wcu-wrapper">

                 
                    <div className="wcu-left">
                        <p className="wcu-subtitle">{service.title}</p>

                        <h1 className="wcu-heading">{service.heading}</h1>

                        <p
                            className="wcu-description"
                            dangerouslySetInnerHTML={{ __html: service.description }}
                        />

                        {cards.map((card, index) => (
                            <div className="wcu-progress-item" key={index}>
                                <div className="wcu-progress-top">
                                    <p className="wcu-progress-title">
                                        {card.label_name}
                                    </p>
                                    <p className="wcu-progress-value">{card.percentage}%</p>
                                </div>

                                <div className="wcu-progress-bar">
                                    <div
                                        className="wcu-progress-fill"
                                        style={{ width: `${card.percentage}%` }}
                                    ></div>
                                </div>
                            </div>
                        ))}

                    </div>

                    <div className="wcu-right">
                        <img src={service.image} alt="Preview" className="wcu-image" />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default WhyChooseUsPreview;
